import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../../hooks/useApi";
import Loader from "../../../../DefaultStyles/Loader";
import { Textarea } from "../../../../Input/Textarea";
import AlertModal from "../../../../Modal/AlertModal";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { DeleteModalLabel } from "../../../Users/UserDetail/CommentModal/CommentDeleteModal";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";

interface PartyExitRevertModalProps extends DefaultModalCommonProps {
  revertData: {
    user: string;
    partyId: number;
  };
}

export default function PartyExitRevertModal({
  closeEvent,
  confirmEvent,
  revertData,
}: PartyExitRevertModalProps) {
  console.log(revertData);

  const [reason, setReason] = useState("");
  const [execute, setExecute] = useState(false);
  const [errorString, setErrorString] = useState("");
  const [errorModal, setErrorModal] = useState(false);
  const [checkAlert, setCheckAlert] = useState(false);

  const [hasReturnPointModal, setHasReturnPointModal] = useState(false);

  const { response, error, loading } = useApi({
    method: "post",
    url: execute ? `party/revertExit` : undefined,
    data: {
      uid: Number(revertData?.user?.split("_")[0]),
      partyid: revertData?.partyId ?? 0,
      reason,
    },
  });

  console.log(response);
  console.log(error);

  useEffect(() => {
    if (response?.status === 201 || response?.status === 200) {
      if (response?.data?.result === 2) {
        setHasReturnPointModal(true);
      } else {
        closeEvent();

        if (confirmEvent) {
          confirmEvent();
        }
        toast.success("파티 탈퇴가 취소되었습니다.");
      }
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      setErrorString(`${error.data}`);
      setErrorModal(true);
    }
  }, [error]);

  return (
    <>
      <DefaultModalLayout
        closeEvent={() => closeEvent()}
        confirmEvent={() => setCheckAlert(true)}
        modalTitle="파티 탈퇴 취소"
        isDeleteModal={true}
        isSmallModal={true}
        confirmBtnText="계속"
        confirmDisabled={reason === ""}
      >
        <DeleteModalLabel>취소 사유</DeleteModalLabel>

        <Textarea
          placeholder="취소 사유 입력(100글자 이내)"
          onChange={(e) => setReason(e.target.value)}
          value={reason}
          maxLength={100}
        />
      </DefaultModalLayout>

      {checkAlert && (
        <AlertModal
          title={`${revertData?.user}님의\n파티 탈퇴가 취소됩니다.\n계속하시겠습니까?`}
          confirmEvent={() => {
            setExecute(true);
            setCheckAlert(false);
          }}
          cancelEvent={() => setCheckAlert(false)}
        />
      )}

      {errorModal && (
        <AlertModal
          title={errorString}
          customCancelBtn={<></>}
          confirmEvent={() => {
            setErrorModal(false);
            setExecute(false);
          }}
        />
      )}

      {/* 탈퇴 취소시, 환불 포인트가 있을 경우 */}
      {hasReturnPointModal && (
        <AlertModal
          title={
            <span>
              탈퇴 취소 처리가 완료되었습니다.
              <br />
              <strong>포인트 환불 여부</strong>를 확인하고,
              <br />
              <strong>포인트 임의차감</strong>을 꼭 진행해 주세요.
            </span>
          }
          confirmEvent={() => {
            setHasReturnPointModal(false);
            closeEvent();

            if (confirmEvent) {
              confirmEvent();
            }
          }}
          customCancelBtn={<></>}
          btnColor="mint"
        />
      )}

      {loading && <Loader />}
    </>
  );
}
